import { useContext, useEffect, useState } from 'react';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import i18nContext from 'components/i18n-context';
import DocumentRequestsList from './DocumentRequestsList';
import { NewContainer } from 'uikit/NewContainer/NewContainer';
import './LatestTransactions.scss';

const DocumentRequestsTable = ({ documentRequestStore, userStore }) => {
  const i18n = useContext(i18nContext);
  const navigate = useNavigate();
  const [documentRequests, setDocumentRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDocumentRequests = async () => {
      // Wait for userStore to load and customerNumber to be available
      const customerNumber = userStore?.userData?.account?.account_number;
      if (!userStore || !customerNumber) {
        // Don't set loading to false here, wait for customer data
        if (!userStore?.isLoading) {
          setIsLoading(false);
        }
        return;
      }

      try {
        setIsLoading(true);
        // Fetch document requests
        const requests = await documentRequestStore.fetchRequestsList(customerNumber);
        // Filter only REQUESTED status and set the requests to state
        const requestedOnly = (requests || []).filter((req) => req.status === 'REQUESTED');
        setDocumentRequests(requestedOnly);
        setIsLoading(false);
      } catch (error) {
        console.error('Failed to fetch document requests:', error);
        setIsLoading(false);
      }
    };

    fetchDocumentRequests();
  }, [documentRequestStore, userStore, userStore?.userData?.account?.account_number]);

  const handleUploadClick = (requestId) => {
    // Always open in new tab
    window.open(`/document-request/${requestId}`, '_blank');
  };

  // Don't render if no requests
  if (!isLoading && documentRequests.length === 0) {
    return null;
  }

  return (
    <section className={'page-container latest-transactions-compact'}>
      <NewContainer
        className={'transactions-container-main content-card-wrapper'}
        header={i18n.getMessage('container.documentRequests')}
      >
        <DocumentRequestsList
          isLoading={isLoading}
          documentRequests={documentRequests}
          onUploadClick={handleUploadClick}
        />
      </NewContainer>
    </section>
  );
};

DocumentRequestsTable.propTypes = {
  documentRequestStore: MobXPropTypes.observableObject,
  userStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  documentRequestStore: stores.documentRequestStore,
  userStore: stores.userStore
}))(observer(DocumentRequestsTable));
